import { isNonArrayObject, objectEntries, type ReadonlyRecord } from '../../../../utils'

const recursivelyMapPlainProperties = (props: ReadonlyRecord<string, unknown>, parts: readonly string[] = []): ReadonlyRecord<string, string> =>
    objectEntries(props).reduce<ReadonlyRecord<string, string>>((r, [name, value]) => {
        const newParts = [...parts, name]
        return { ...r, ...(isNonArrayObject(value) ? recursivelyMapPlainProperties(value, newParts) : { [newParts.join('.')]: String(value) }) }
    }, {})

/**
 * This function intakes properties, as complex as they may be and converts them to strings
 * If prop value is a JSON-object, flattens it e.g. 'foo': { 'bar': 'baz' } -> 'foo.bar': 'baz'
 *
 * Edge-case: if object's keys contain dot, some values might be overwritten, e.g.:
 * 'foo.bar': 1, foo: { bar: 2 } would result into a single entry - 'foo.bar': '2'
 */
export const safelyMapPlainProperties = (props: ReadonlyRecord<string, unknown>): ReadonlyRecord<string, string> => recursivelyMapPlainProperties(props)
